var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuStatusOkTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59999 6.9999C1.59999 4.01756 4.01766 1.5999 6.99999 1.5999C9.98233 1.5999 12.4 4.01756 12.4 6.9999C12.4 9.98224 9.98233 12.3999 6.99999 12.3999C4.01766 12.3999 1.59999 9.98224 1.59999 6.9999ZM6.99999 0.399902C3.35491 0.399902 0.399994 3.35482 0.399994 6.9999C0.399994 10.645 3.35491 13.5999 6.99999 13.5999C10.6451 13.5999 13.6 10.645 13.6 6.9999C13.6 3.35482 10.6451 0.399902 6.99999 0.399902ZM9.42426 6.09083C9.65857 5.85651 9.65857 5.47662 9.42426 5.2423C9.18994 5.00799 8.81005 5.00799 8.57573 5.2423L6.33333 7.4847L5.42426 6.57563C5.18994 6.34132 4.81004 6.34132 4.57573 6.57563C4.34142 6.80995 4.34142 7.18985 4.57573 7.42416L5.90906 8.7575C6.14338 8.99181 6.52328 8.99181 6.75759 8.7575L9.42426 6.09083Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuStatusOkTransparent);
export default __webpack_public_path__ + "static/media/a11ymenu_status_ok_transparent.7e1483743bf1cebc6c8ef52b7e944754.svg";
export { ForwardRef as ReactComponent };